<template>
  <div class="page">
    <div class="partition-one">
      <div class="content-one">
        <div class="image-cont">
          <div class="image"></div>
        </div>
        <div class="text-cont">
          <div class="title-cont">
            <h3 class="title">
              {{ "about_us.titles.rethink" | translate }}
            </h3>
          </div>
          <p>{{ "about_us.descriptions.rethink" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="partition-two">
      <div class="left">
        <div class="title-cont">
          <h3 class="title">
            {{ "about_us.titles.more" | translate }}
          </h3>
        </div>
        <p>{{ "about_us.descriptions.more" | translate }}</p>
      </div>
      <div class="right">
        <div class="logo-container">
          <div class="logo"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
      </div>
    </div>

    <div class="partition-three">
      <div class="left">
        <div class="img"></div>
      </div>
      <div class="right">
        <div class="text-cont">
          <div class="title-cont">
            <h3 class="title">
              {{ "about_us.titles.fingertips" | translate }}
            </h3>
          </div>
          <p>{{ "about_us.descriptions.fingertips" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="partition-four">
      <div class="left">
        <div class="text-cont">
          <div class="title-cont">
            <h3 class="title">
              {{ "about_us.titles.story" | translate }}
            </h3>
          </div>
          <p>{{ "about_us.descriptions.story" | translate }}</p>
        </div>
      </div>
      <div class="right">
        <div class="img"></div>
        <div class="gradient"></div>
      </div>
    </div>

    <div class="partition-five">
      <div class="top">
        <h3 class="title">
          {{ "about_us.titles.founders" | translate }}
        </h3>
        <p>{{ "about_us.descriptions.founders" | translate }}</p>
      </div>
      <div class="middle">
        <div class="founder">
          <div class="img ceo"></div>
          <h3>Louis Tillessen</h3>
          <p>Co-founder & CEO</p>
        </div>
        <div class="founder">
          <div class="img cto"></div>
          <h3>Dylan Puser</h3>
          <p>Co-founder & CTO</p>
        </div>
      </div>
      <div class="bottom">
        <p>{{ "about_us.descriptions.learn_more" | translate }}</p>
        <div class="button">
          <a href="mailto:info@gyra.shop" class="link"
            ><p>{{ "about_us.titles.get_in_touch" | translate }}</p></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUsPage"
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}
.content-one {
  display: flex;
  flex-direction: column-reverse;
  padding-bottom: 0;
  @media (min-width: $gyra-breakpoint-lg) {
    flex-direction: row;
    padding-bottom: 100px;
  }
  .image-cont {
    display: flex;
    width: 100vw;
    height: 100vh;
    position: relative;
    @media (min-width: $gyra-breakpoint-lg) {
      min-width: 500px;
      min-height: 650px;
    }

    @media (min-width: $gyra-breakpoint-xl) {
      min-width: 725px;
      min-height: 945px;
    }

    justify-content: center;
    align-items: center;

    .image {
      margin-top: 100px;
      @media (min-width: $gyra-breakpoint-lg) {
        margin-top: 0;
      }
      height: 100%;
      width: 100%;
      background-image: url("../assets/images/about_us/about_us_top.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .gradient {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      @media (min-width: $gyra-breakpoint-lg) {
        display: none;
      }
      height: 100%;
      width: 100%;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  .title-cont {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    @media (min-width: $gyra-breakpoint-lg) {
      justify-content: flex-end;
    }
  }

  .text-cont {
    margin-top: 10vh;
    margin-left: $gyra-margin-sides-mobile;
    margin-right: $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin-top: 20vh;
      margin-left: $gyra-margin-sides;
      padding-right: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-top: 25vh;
    }
    width: auto;
    display: flex;
    flex-direction: column;
    h3 {
      width: 100%;
    }
    h3,
    p {
      text-align: center;
      @media (min-width: $gyra-breakpoint-lg) {
        text-align: right;
      }
    }
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
  @media (min-width: $gyra-breakpoint-lg) {
    font-size: 46px;
  }
}
p {
  font-size: 16px;
  margin-top: 70px;
  @media (min-width: $gyra-breakpoint-lg) {
    font-size: 16px;
  }
}
.partition-two {
  background-color: $gyra-grey-lightest;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (min-width: $gyra-breakpoint-lg) {
    padding-top: 192px;
    padding-bottom: 192px;
  }

  h3,
  p {
    text-align: center;
    @media (min-width: $gyra-breakpoint-lg) {
      text-align: unset;
    }
  }

  .left {
    width: 100%;
    @media (min-width: $gyra-breakpoint-xl) {
      width: 60%;
    }
  }

  .title-cont {
    margin-left: $gyra-margin-sides-mobile;
    margin-right: $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin-left: $gyra-margin-sides;
      margin-right: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-right: 0;
    }
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .title:last-child {
      margin-left: 10px;
    }
  }
  p {
    margin-top: 70px;
    margin-left: $gyra-margin-sides-mobile;
    margin-right: $gyra-margin-sides-mobile;

    @media (min-width: $gyra-breakpoint-lg) {
      margin-left: calc(#{$gyra-margin-sides} + 46px);
      margin-right: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-right: 0;
    }
  }

  .right {
    position: absolute;
    right: 0;
    width: 40%;
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }
  .logo {
    width: 214px;
    height: 274px;
    background-image: url("../assets/images/gyra_logo_big/Totem_Grey@3x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.5;
    @media (min-width: $gyra-breakpoint-xl) {
      opacity: 1;
    }
  }
  .logo-container {
    position: relative;
  }
  .circle {
    position: absolute;

    width: 300px;
    height: 300px;
    border-radius: 10000px;
    border: 2px solid $gyra-salmon;
    top: -20px;
    left: -40px;
    @media (min-width: $gyra-breakpoint-lg) {
      width: 500px;
      height: 500px;
      top: -76px;
      left: -150px;
    }
    opacity: 0.5;
    @media (min-width: $gyra-breakpoint-xl) {
      opacity: 1;
    }

    &:nth-child(2) {
      top: 5px;
      left: -60px;
      @media (min-width: $gyra-breakpoint-lg) {
        top: -79px;
        left: -110px;
      }
    }
    &:nth-child(3) {
      top: -30px;
      left: -50px;
      @media (min-width: $gyra-breakpoint-lg) {
        top: -110px;
        left: -150px;
      }
    }
  }
}
.partition-three {
  display: flex;
  flex-direction: row;
  .title-cont {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    @media (min-width: $gyra-breakpoint-lg) {
      justify-content: flex-end;
    }
  }
  .text-cont {
    margin-top: 10vh;
    margin-left: $gyra-margin-sides-mobile;
    padding-right: $gyra-margin-sides-mobile;

    @media (min-width: $gyra-breakpoint-lg) {
      margin-top: 20vh;
      margin-left: $gyra-margin-sides;
      padding-right: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-top: 25vh;
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    h3,
    p {
      text-align: center;
      @media (min-width: $gyra-breakpoint-lg) {
        text-align: right;
      }
    }
  }

  .right {
    width: 100%;
    @media (min-width: $gyra-breakpoint-md) {
      width: 70%;
      padding-right: $gyra-margin-sides;
    }
    padding-right: $gyra-margin-sides-mobile;
  }

  .left {
    display: none;
    @media (min-width: $gyra-breakpoint-md) {
      display: flex;
    }
    width: 30%;
    justify-content: center;
    align-items: center;
    .img {
      margin-left: $gyra-margin-sides-mobile;
      margin-top: 100px;
      @media (min-width: $gyra-breakpoint-lg) {
        margin-left: 0;
      }
      @media (min-width: $gyra-breakpoint-xl) {
        margin-top: 180px;
      }
      width: 355px;
      height: 656px;
      background-image: url("../assets/images/about_us/smartmockups_kev47g0x.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

.partition-four {
  position: relative;
  margin-top: 80px;
  @media (min-width: $gyra-breakpoint-xl) {
    margin-top: 200px;
  }
  display: flex;
  flex-direction: column-reverse;
  @media (min-width: $gyra-breakpoint-sm) {
    flex-direction: row;
  }
  margin-bottom: 100px;
  .left {
    padding-top: 0;
    margin-top: -200px;
    @media (min-width: $gyra-breakpoint-sm) {
      padding-top: 100px;
      margin-top: 0;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      padding-top: 150px;
      width: 50%;
    }
    width: 100%;
    .title-cont {
      margin-top: 100px;
      @media (min-width: $gyra-breakpoint-xl) {
        margin-top: 0;
      }
      margin-left: $gyra-margin-sides-mobile;
      margin-right: $gyra-margin-sides-mobile;
      @media (min-width: $gyra-breakpoint-lg) {
        margin-left: $gyra-margin-sides;
        margin-right: $gyra-margin-sides;
      }
      @media (min-width: $gyra-breakpoint-xl) {
        margin-right: 0;
      }
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .title:last-child {
        margin-left: 10px;
      }
    }
    h3 {
      width: 100%;
      text-align: center;
      @media (min-width: $gyra-breakpoint-lg) {
        text-align: unset;
      }
    }
    p {
      margin-top: 70px;
      text-align: center;
      margin-left: $gyra-margin-sides-mobile;
      margin-right: $gyra-margin-sides-mobile;

      @media (min-width: $gyra-breakpoint-lg) {
        margin-left: calc(#{$gyra-margin-sides} + 46px);
        margin-right: $gyra-margin-sides;
        text-align: unset;
      }
      @media (min-width: $gyra-breakpoint-xl) {
        margin-right: 0;
      }
    }
  }
  .right {
    margin-top: 100px;
    @media (min-width: $gyra-breakpoint-sm) {
      position: absolute;
      padding-left: 100px;
      margin-top: 0;
    }
    position: relative;
    padding-left: 0;
    right: 0;
    top: -160px;
    @media (min-width: $gyra-breakpoint-md) {
      top: -200px;
    }
    z-index: -10;
    .img {
      @media (min-width: $gyra-breakpoint-sm) {
        position: absolute;
        top: 180px;
        right: 0;
        width: 743px;
        height: 844px;
      }
      position: relative;

      @media (min-width: $gyra-breakpoint-xl) {
        top: 220px;
      }
      width: 100vw;
      height: calc(100vw * 1.3);
      background-image: url("../assets/images/about_us/Untitled design-2.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      box-shadow: none;
      @media (min-width: $gyra-breakpoint-xl) {
        box-shadow: 10px 10px 50px 0 rgba(0, 0, 0, 0.16);
      }
    }

    .gradient {
      position: absolute;
      top: 180px;
      right: 0;
      @media (min-width: $gyra-breakpoint-xl) {
        top: 0;
      }
      width: 743px;
      height: 844px;
      display: none;
      @media (min-width: $gyra-breakpoint-sm) {
        display: flex;
      }
      @media (min-width: $gyra-breakpoint-xl) {
        display: none;
      }
      background: rgb(255, 255, 255);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 10%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}

.partition-five {
  margin-top: 100px;
  @media (min-width: 411px) {
    margin-top: 300px;
  }

  .top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h3 {
      width: fit-content;
      text-align: center;
    }
    p {
      text-align: center;
      width: 80%;
      @media (min-width: $gyra-breakpoint-sm) {
        width: 60%;
      }
    }
  }

  .middle {
    margin-top: 65px;
    display: flex;
    flex-direction: column;
    @media (min-width: $gyra-breakpoint-md) {
      flex-direction: row;
    }
    justify-content: space-evenly;

    .founder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      height: 600px;
      .img {
        width: 300px;
        height: 300px;
        background-position: top;
        background-repeat: no-repeat;
        background-size: cover;
        @media (min-width: $gyra-breakpoint-sm) {
          width: 360px;
          height: 360px;
        }
        border-radius: 200px;
      }
      h3 {
        font-size: 33px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        text-align: center;
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 100px;
    @media (min-width: $gyra-breakpoint-sm) {
      padding-bottom: 190px;
    }
    p {
      @media (min-width: $gyra-breakpoint-lg) {
        font-size: 16px;
      }
      width: 80%;
      @media (min-width: $gyra-breakpoint-sm) {
        width: 60%;
      }
      margin-top: 150px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
    }

    .button {
      width: 275px;
      height: 58px;
      background-color: $gyra-salmon;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      p {
        margin: 0;
        width: 100%;
      }
      a {
        width: 100%;
      }

      .link {
        color: $gyra-salmon;
        text-decoration: underline;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
.ceo {
  background-image: url("../assets/images/about_us/IMG_7430-01sw.jpg");
}
.cto {
  background-image: url("../assets/images/about_us/03A9907D-9B2A-49B6-A737-C0C9DC66395F_1_201_a.jpeg");
}
</style>
